import React, { useState } from 'react';
import styled from 'styled-components';
import { GrLinkPrevious } from "react-icons/gr";
import { useSelector } from 'react-redux';
import { setSelectedCategory, setSelectedSubCategory, setSubCategoryList } from '../../features/messages/messageSlice';
import { useDispatch } from 'react-redux';

const Container = styled.div`
    width: 100%;
    color:  ${({ theme }) => theme.mainTextColor};

    .category-container {
        width: 100%;
        padding: 20px;
        .category-list, .subcategory-list {
            display: flex;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap-reverse;
            transition: opacity 0.5s ease, transform 0.5s ease;
            &.fade-out {
                opacity: 0;
                transform: translateY(20px);
            }
            &.fade-in {
                opacity: 1;
                transform: translateX(0);
            }
        }
        .category-item, .subcategory-item {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            background-color: ${({ theme }) => theme.mainBgColor};
            border: 1px solid ${({ theme }) => theme.mainBorderColor};
            padding: 10px;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            cursor: pointer;
        }
    }

    .selected{
        background-color: var(--color-main) !important;
        color: #fff;
    }
`;

const MessageCategories = () => {
    const dispatch = useDispatch();
    const {selectedCategory, selectedSubCategory, subCategoryList, supportCategoryList} = useSelector((state) => state.message);
    const [fadeClass, setFadeClass] = useState('');

    const handleCategoryClick = (category) => {
        
        if (category.subCategories$values?.length > 0) {
            setFadeClass('fade-out');
            setTimeout(() => {
                dispatch(setSubCategoryList(category.subCategories.$values));
                dispatch(setSelectedCategory(null));
                setFadeClass('fade-in');
            }, 500);
        }else{
            dispatch(setSelectedCategory(category));
        }
    };

    const handleBackToCategories = () => {
        setFadeClass('fade-out');
        dispatch(setSelectedCategory(null));
        setTimeout(() => {
            dispatch(setSelectedSubCategory(null));
            dispatch(setSubCategoryList([]));
            setFadeClass('fade-in');
        }, 500);
    };

    return (
        <Container>
            <div className="category-container">
                {subCategoryList?.length < 1 ? (
                    <div className={`category-list ${fadeClass}`}>
                        {supportCategoryList.map((item) => (
                            <div
                                key={item.id}
                                className={`category-item ${selectedCategory?.id === item?.id ? 'selected' : ''}`}
                                onClick={() => handleCategoryClick(item)}
                            >
                                {item.name}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={`subcategory-list ${fadeClass}`}>
                        <div className="subcategory-item" onClick={handleBackToCategories}>
                            <GrLinkPrevious />
                        </div>
                        {subCategoryList?.map((item) => (
                            <div key={item.id} onClick={() => dispatch(setSelectedSubCategory(item))} className={`subcategory-item ${selectedSubCategory?.id === item?.id ? 'selected' : ''}`}>
                                {item.name}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Container>
    );
};

export default MessageCategories;
